import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import SurgeryImage from "../../Assets/Icons/SurgeryCreate.png";

const useStyle = makeStyles((theme) => ({
  rsRowColor: {
    width: "450px",
    height: "300px",
    borderRadius: "10px",
    backgroundColor: "white",
    display: "block",
    padding: "30px",
    paddingLeft: "30px",
    margin: "10px",
    paddingRight: "30px",
    justifyContent: "space-between",
    alignItems: "center",
    position: "sticky",
    "&>span": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      "&>img": {
        width: "100%",
        display: "flex",
      },
      "&>svg": {
        zIndex: "2",
        position: "absolute",
        width: "50px",
        height: "50px",
      },
    },
    "&>div": {
      "&>button": {
        marginTop: "10px",
        borderRadius: "40px",
        height: "40px",
        whiteSpace: "nowrap",
      },
      "&>h3": {
        marginTop: "15px",
        fontSize: "22px",
        fontWeight: "400",
        // color: "black",
        cursor: "pointer",
        width: "fit-content",
        "&:hover": {
          textDecoration: "underline",
          color: "rgb(123, 192, 68)",
        },
      },
    },
    [theme.breakpoints.down(1066)]: {
      width: "94%",
      height: "350px",
    },
    [theme.breakpoints.down(500)]: {
      // display: "block",
      // width: "330px",
      // height: "350px",
      // "&>span": {
      //   "&>img": {
      //     width: "300px",
      //     height: "200px",
      //     display: "flex",
      //   },
      // },
    },
  },
}));

const HowToCommonCard = (props) => {
  const { setVideoDialogOpen, setLinkvideo, setTitle, Link, titlename, img } =
    props;
  const classes = useStyle();
  return (
    <Box
      className={classes.rsRowColor}
      onClick={(e) => {
        setVideoDialogOpen(true);
        setLinkvideo(Link);
        setTitle(titlename);
      }}
    >
      <span>
        <img src={img} width="400px" height="200px" />
        <PlayCircleOutlineIcon />
      </span>
      <Box>
        <Typography variant="h3">{titlename}</Typography>
      </Box>
    </Box>
  );
};

export default HowToCommonCard;
